import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { tomos } from '../data/content';
export function Tomos() {
  return <section id="contenido" className="w-full bg-paper py-20 md:py-28" aria-labelledby="tomos-title" data-id="element-166" data-mp="13d923tw90sip">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-167" data-mp="1h4nj5v6lijn4">
        <div className="flex flex-col gap-6 border-b border-line pb-10 md:flex-row md:items-end md:justify-between" data-id="element-168" data-mp="1cbuflamv5hcm">
          <div data-id="element-169" data-mp="1r07g8kwwbodg">
            <p className="inline-flex items-center gap-2 rounded-full bg-accent-soft px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-accent-dark" data-id="element-170" data-mp="1qzp8os4s9nq8">
              <TrophyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="202glav9eapjg" />
              El sistema completo
            </p>
            <h2 id="tomos-title" className="mt-5 max-w-2xl text-4xl font-extrabold tracking-tightest text-ink md:text-5xl" data-id="element-172" data-mp="1w1oes9rwqyqv">
              Mega Pack Kinesiología Remasterizada
            </h2>
          </div>
          <p className="text-sm font-semibold uppercase tracking-[0.12em] text-ink-muted md:text-right" data-id="element-173" data-mp="1oopfoxq6q6e">
            3 Tomos · 150 páginas
            <br data-id="element-174" data-mp="39quo2260umdj" />
            Todo listo para usar
          </p>
        </div>

        <div className="divide-y divide-line" data-id="element-175" data-mp="3ep5ue2x3yer0">
          {tomos.map(tomo => <article key={tomo.number} className="grid gap-8 py-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-16" data-id="element-176" data-mp="3jfm9rskhoag0">
              <div data-id="element-177" data-mp="3of8pc8nsi2rz">
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-accent-dark" data-id="element-178" data-mp="3odnwqol1ctwr">
                  <span aria-hidden="true" className="text-base" data-id="element-179" data-mp="3sehh57z9rqkw">
                    {tomo.emoji}
                  </span>
                  {tomo.number}
                </p>
                <h3 className="mt-3 text-3xl font-extrabold tracking-tightest text-ink md:text-4xl" data-id="element-180" data-mp="681ee0gd6hon">
                  {tomo.title}
                </h3>
                <p className="mt-5 max-w-xl text-base leading-relaxed text-ink-muted md:text-lg" data-id="element-181" data-mp="280fsspjp940b">
                  {tomo.description}
                </p>
              </div>

              <div className="rounded-2xl bg-paper-card p-6 ring-1 ring-line md:p-8" data-id="element-182" data-mp="2001eu84na18u">
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-ink-muted" data-id="element-183" data-mp="1vzqzw5yvk0hu">
                  Incluye
                </p>
                <ul className="mt-5 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-184" data-mp="24yulbglikrzi">
                  {tomo.includes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-ink" data-id="element-185" data-mp="2ixu5oc1zukpv">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={3} aria-hidden="true" data-id="element-186" data-mp="2evz8njr3ithw" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}